import { useClassName } from '@/styles/Accordion';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type AccordionContentProps = ComponentProps<'div'>;

export const AccordionContentComponent: Component<AccordionContentProps> = ({ children, ...props }) => {
  const className = useClassName('content', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
